<template>
  <portlet
          :actionsBlock="true"
          :icon="'fad fa-boxes'"
          :title="$t('products.title')"
  >
    <div slot="actionsBlock">
      <create-button
              :link="'create-product'"
              :text="$t('products.createProduct')"
      />
    </div>

    <template slot="portletBody">
      <data-tables
              :columns="getColumns()"
              :customFilters="customFilters"
              :deleteFunction="deleteProduct"
              :rows="getProducts"
              :tableClass="tableClass"
              :tableInitOptions="tableInitOptions"
              @checkboxChanged="setSelection($event)"
              class="first-checkbox"
              deleteClass="delete"
              routerLinkClass="dt-router-link"
              tableID="workflows-dt"
              v-if="getProducts.length && renderedComponent"
      />
    </template>

    <div class="col text-right" slot="portletFooter">
      <button class="btn btn-cancel">{{$t('ui.cancel')}}</button>
      <button class="btn btn-primary ml-4" type="submit">{{$t('ui.save')}}</button>
    </div>

  </portlet>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {dataTables} from '../../mixins/dataTables';

  // @vuese
  // @group Products
  // Shows product overview page.
  export default {
    name: 'Products',
    mixins: [dataTables],
    data() {
      return {
        filterOpen: false,
        filterOpenClass: 'm-hide-lg',
        selectedRows: [],
        selectAll: false,

        itemsSelected: [],
        tableInitOptions: {
          order: [[1, 'asc']]
        },
        customFilters: [
          {
            filter: 'arrayContains',
            keyToFilter: 'id',
            options: {
              values: []
            }
          },
          {
            filter: 'arrayContains',
            keyToFilter: 'id',
            options: {
              values: []
            }
          }
        ]
      }
    },
    computed: {
      ...mapGetters('products', [
        'getProducts'
      ])
    },
    methods: {
      /**
       * @vuese
       * Sets up the columns for datatables package from https://git.motivate.nl/js-awesome/motivate-framework-components/blob/v2/src/components/DataTable.vue
       */
      getColumns() {
        let self = this;
        return [
          {
            data: null,
            name: '',
            searchable: false,
            sortable: false,
            render(data) {
              if(self.selectedRows.includes(data.id)) {
                return '<div class="custom-control custom-checkbox"><input value="' + data.id + '" type="checkbox" id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
              } else {
                return '<div class="custom-control custom-checkbox"><input value="' + data.id + '" type="checkbox" id="' + data.id + '" class="custom-control-input"><label class="custom-control-label" for="' + data.id + '">&nbsp;</label></div>'
              }
            }
          },
          {
            data: null,
            name: self.$t('products.table.name'),
            responsivePriority: 1,
            render(data) {
              return '<a data-to="products/' + data.id + '" class="dt-router-link">' + data.name + '</a>'
            }
          },
          {
            data: null,
            name: self.$t('products.table.createdAt'),
            render(data) {
              return moment(data.created_at).format('DD-MM-YYYY')
            }
          },
          {
            data: null,
            searchable: false,
            orderable: false,
            render(data) {
              return '<a data-to="products/' + data.id + '" class="action-icon dt-router-link"><i class="far fa-edit"></i></a>' +
                '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i class="far fa-trash-alt delete"></i></a>'
            }
          }
        ]
      },

      /**
       * @vuese
       * Add selected ID's to array, which is used to delete selection.
       * @arg `selectedItem`
       */
      setSelection(selectedItem) {
        this.selectedRows = selectedItem
      },

      /**
       * @vuese
       * Delete product, or multiple when a selection is made to delete
       * @arg `payload` represents the selection to be deleted
       */
      deleteProduct(payload) {
        let itemsToDelete = [];
        let swalText = payload.name;
        if(payload === 'selection') {
          itemsToDelete = this.selectedRows;
          swalText = this.$t('swal.deleteSelection')
        } else {
          itemsToDelete.push(payload.id)
        }
        this.swalDelete(swalText).then(result => {
          if(result.value) {
            _.forEach(itemsToDelete, item => {
              this.$store.dispatch('products/delete', item)
            });
            this.selectedRows = [];
            this.swalToastSuccess(this.$t('products.deleted'));
            this.renderComponent()
          }
        })
      },
    }
  }
</script>
